<template>
  <svg width="100%" height="100%" viewBox="0 0 46 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="44.5" y="30.1" width="34.6667" height="28.6" rx="5.5" transform="rotate(180 44.5 30.1)" stroke="white" stroke-width="3"/>
    <rect x="36.1667" y="36.5" width="34.6667" height="28.6" rx="5.5" transform="rotate(180 36.1667 36.5)" stroke="white" stroke-width="3"/>
  </svg>
</template>

<script>
export default {
  name: 'episodes-icon'
}
</script>

<style lang="scss" scoped>
svg > rect {
  stroke: $player-footer-icons-color;
  fill: $player-hud-background-color;
}
</style>
